import { createStore }     from 'vuex'
import { getSocket }       from '@/plugins/SocketIOPlugin'
import { responseChecker } from '@/plugins/ResponseCheckerPlugin'

import createSocketIOStorePlugin from '@/plugins/SocketIOStorePlugin'
import NotificationPlugin from '@/plugins/NotificationPlugin'



function sorting(data, column, order) {
  let target = {}

  data.sort(function(a, b) {
    if((a[column] == null ? '' : a[column]) > (b[column] == null ? '' : b[column])) return order ? 1 : -1
    if((a[column] == null ? '' : a[column]) < (b[column] == null ? '' : b[column])) return order ? -1 : 1
    if((a[column] == null ? '' : a[column]) == (b[column] == null ? '' : b[column])) {
      if((a.name && a.name > b.name) || (a.domain && a.domain > b.domain)) return order ? 1 : -1
      if((a.name && a.name < b.name) || (a.domain && a.domain < b.domain)) return order ? -1 : 1
    }
    return 0
  })

  for(let item of data) {
    target[item.key] = item
  }

  return target
}



function checkFilter(data) {
  let filterActive = false
  for(let key in data) {
    if(!filterActive) {
      filterActive = ((!Array.isArray(data[key]) && data[key] != null) || (Array.isArray(data[key]) && data[key].length > 0)) ? true : false
    }
  }
  return filterActive
}



export default createStore({
  state: {
    user: {
      data:       null,
      token:      null,
      isLoggedIn: false
    },

    preloader: false,

    sort: {
      data: {}
    },

    filter: {
      isEnabled: false,
      active:    false,
      data:      {}
    },

    selectedSites: null,

    users:      null,
    geos:       null,
    langs:      null,
    themes:     null,
    sellers:    null,
    currencies: null,
    sellers:    null,
    sites:      null,

    error: {
      id:      null,
      title:   null,
      message: null
    },

    popups: {
      sellers: { isEnabled: false },
      filter:  { isEnabled: false },
      comment: { isEnabled: false }
    },
  },


  
  getters: {
    getUserEmail: (state) => {
      return state.user.data.email
    },







    getTheme(state) {
      return state.theme
    }
  },



  mutations: {
    setPreloader: (state, data) => {
      state.preloader = data
    },

    setToken: (state, data) => {
      state.user.data = data.user
      state.user.token = data.token
      state.user.isLoggedIn = data.token !== null ? true : false
      localStorage.setItem('token', data.token)
      if(data.token !== null) {
        createSocketIOStorePlugin(data.token)
      }

      if(data.user.sort) {
        state.sort.data = data.user.sort
      } else {
        state.sort.data = {
          geos: 'name',    sites: 'name',    users: 'name',    langs: 'name',    themes: 'name',    currencies: 'name',    sellers: 'name',
          geosOrder: true, sitesOrder: true, usersOrder: true, langsOrder: true, themesOrder: true, currenciesOrder: true, sellersOrder: true
        }
      }

      if(data.user.filter) {
        state.filter.data = data.user.filter
      } else {
        state.filter.data = {
          daFrom:            null,
          daTo:              null,
          drFrom:            null,
          drTo:              null,
          ahrefsFrom:        null,
          ahrefsTo:          null,
          geoKey:            [],
          trafficFrom:       null,
          trafficTo:         null,
          langKey:           [],
          themeKey:          [],
          iG:                null,
          bannerPriceFrom:   null,
          bannerPriceTo:     null,
          bannerCurrencyKey: [],
          sellers:           [],
          comment:           null
        }
      }

      state.filter.active = checkFilter(state.filter.data)
    },

    setTheme: (state, data) => {
      state.user.data.theme = data
    },

    setSort: async (state, { model, category, data }) => {
      for(let key in data) {
        state.sort.data[key] = data[key]
      }
      const response = await getSocket().emitWithAck('update_settings', { model: 'User', data: { key: state.user.data.key, sort: state.sort.data } })
      if((await responseChecker(response)).success) {
        state[category] = data[category] ? sorting(Object.values(state[category]), state.sort.data[category], state.sort.data[`${category}Order`]) : null
        await getSocket().emit('get_settings', 'User')
      }
    },

    setFilter: async (state, data) => {
      for(let key in data) {
        if(key == 'geoKey' || key == 'langKey' || key == 'themeKey' || key == 'bannerCurrencyKey' || key == 'sellers') {
          if(data[key] == null || data[key] == '') {
            data[key] = [] 
          }
        } else {
          if(typeof data[key] != 'boolean' && data[key] == '') {
            data[key] = null
          }
        }
      }

      const response = await getSocket().emitWithAck('update_settings', { model: 'User', data: { key: state.user.data.key, filter: data } })
      if((await responseChecker(response)).success) {
        state.filter.data = data
        state.filter.active = checkFilter(data)
        await getSocket().emit('get_settings', 'User')
      }
    },
    setFilterToggle: (state) => {
      state.filter.isEnabled = !state.filter.isEnabled
    },
    resetFilter: (state) => {
      state.filter.data = {
        daFrom:            null,
        daTo:              null,
        drFrom:            null,
        drTo:              null,
        ahrefsFrom:        null,
        ahrefsTo:          null,
        geoKey:            [],
        trafficFrom:       null,
        trafficTo:         null,
        langKey:           [],
        themeKey:          [],
        iG:                null,
        bannerPriceFrom:   null,
        bannerPriceTo:     null,
        bannerCurrencyKey: [],
        sellers:           [],
        comment:           null
      }
      state.filter.active = false
      const response = getSocket().emitWithAck('update_settings', { model: 'User', data: { key: state.user.data.key, filter: state.filter.data } })
    },

    setDisconnect: (state) => {
      state.user.data       = null
      state.user.token      = null
      state.user.isLoggedIn = false
      state.users           = null
      state.geos            = null
      state.langs           = null
      state.themes          = null
      state.currencies      = null
      state.sellers         = null
      state.sites           = null
      localStorage.removeItem('token')
    },



    setUsers:       (state, data) => {
      state.users = sorting(data, state.sort.data.users, state.sort.data.usersOrder)
      if(state.users[state.user.data.key]) {
        for(let key in state.users[state.user.data.key]) {
          if(key == 'name' || key == 'theme' || key == 'sort' || key == "filter") {
            state.user.data[key] = state.users[state.user.data.key][key]
          }
        }
      }
    },
    setGeos:        (state, data) => { state.geos       = sorting(data, state.sort.data.geos,       state.sort.data.geosOrder) },
    setLangs:       (state, data) => { state.langs      = sorting(data, state.sort.data.langs,      state.sort.data.langsOrder) },
    setThemes:      (state, data) => { state.themes     = sorting(data, state.sort.data.themes,     state.sort.data.themesOrder) },
    setCurrencies:  (state, data) => { state.currencies = sorting(data, state.sort.data.currencies, state.sort.data.currenciesOrder) },
    setSellers:     (state, data) => { state.sellers    = sorting(data, state.sort.data.sellers,    state.sort.data.sellersOrder) },
    setSites:       (state, data) => { state.sites      = sorting(data, state.sort.data.sites,      state.sort.data.sitesOrder) },
    setAllSettings: (state, data) => {
      state.users      = data.users      ? sorting(data.users,      state.sort.data.users,      state.sort.data.usersOrder)      : null
      state.geos       = data.geos       ? sorting(data.geos,       state.sort.data.geos,       state.sort.data.geosOrder)       : null
      state.langs      = data.langs      ? sorting(data.langs,      state.sort.data.langs,      state.sort.data.langsOrder)      : null
      state.themes     = data.themes     ? sorting(data.themes,     state.sort.data.themes,     state.sort.data.themesOrder)     : null
      state.currencies = data.currencies ? sorting(data.currencies, state.sort.data.currencies, state.sort.data.currenciesOrder) : null
      state.sellers    = data.sellers    ? sorting(data.sellers,    state.sort.data.sellers,    state.sort.data.sellersOrder)    : null
      state.sites      = data.sites      ? sorting(data.sites,      state.sort.data.sites,      state.sort.data.sitesOrder)      : null
      if(state.users[state.user.data.key]) {
        for(let key in state.users[state.user.data.key]) {
          if(key == 'name' || key == 'theme' || key == 'sort' || key == "filter") {
            state.user.data[key] = state.users[state.user.data.key][key]
          }
        }
      }
    },

    setSelectedSites: (state, data) => {
      state.selectedSites = data
    },



    // createNotification: (state, data) => {
    //   state.error.title   = data.title
    //   state.error.message = data.message
    // },

    

    setPopup: (state, data) => {
      state.popups[data.popupType] = data
      state.popups[data.popupType].isEnabled = true
    },

    resetPopup: (state, data) => {
      for(var key in state.popups[data]) {
        if(key != 'isEnabled') state.popups[data][key] = null
      }
      setTimeout(() => {
        state.popups[data].isEnabled = false
      }, 200)
    }
  },



  actions: {
    setPreloader({ commit }, data)     { commit('setPreloader', data )},

    setToken({ commit }, data)         { commit('setToken', data) },

    setTheme({ commit }, data)         { commit('setTheme', data) },

    setSort({ commit }, data)          { commit('setSort', data) },

    setFilter({ commit }, data)        { commit('setFilter', data) },
    setFilterToggle({ commit })        { commit('setFilterToggle') },
    resetFilter({ commit })            { commit('resetFilter') },

    setUsers({ commit }, data)         { commit('setUsers', data) },
    setGeos({ commit }, data)          { commit('setGeos', data) },
    setLangs({ commit }, data)         { commit('setLangs', data) },
    setThemes({ commit }, data)        { commit('setThemes', data) },
    setCurrencies({ commit }, data)    { commit('setCurrencies', data) },
    setSellers({ commit }, data)       { commit('setSellers', data) },
    setSites({ commit }, data)         { commit('setSites', data) },
    setAllSettings({ commit }, data)   { commit('setAllSettings', data) },

    setSelectedSites({ commit }, data) { commit('setSelectedSites', data) },

    setDisconnect({ commit })          { commit('setDisconnect') },



    async createNotification({ commit }, data) {
      try {
        await NotificationPlugin.create(data)
        // commit('createNotification', data)
      } catch(error) {
        console.log(error)
      }
    },



    setPopup({ commit }, data)   { commit('setPopup', data) },
    resetPopup({ commit }, data) { commit('resetPopup', data) },
  },



  modules: {

  }
})
